// Main component export
export { default as OtpWithTimer } from './OtpWithTimer';
export type { OtpWithTimerProps } from './OtpWithTimer';

// Timer hook exports
export { default as useTimer } from './useTimer';
export { useOtpTimer } from './OtpWithTimer';

// Re-export types and components from react-native-otp-entry for convenience
export { OtpInput } from 'react-native-otp-entry';
export type { OtpInputRef } from 'react-native-otp-entry';
